// API каталога техники.
// Данными управляет админка (lcstonexxi/api_v2/admin), публичный метод — api_v2/api/catalog.
// Ответы сервера уже в формате { status, ... }, поэтому отдаются как есть.

import { postUrl } from '@/run'

const url = '//lc.stone-xxi.ru/api_v2/api/catalog'

// Страница каталога: params — { type: 'new' | 'used', rows, limit, offset },
// ответ — { status, total, data }
const getCatalog = async (params) => {
    return await postUrl(url, params)
}

// Всё для первого экрана одним запросом: сочетания для селектов
// и первые страницы обеих групп — { status, filters, new, used }
const getCatalogInit = async (limit) => {
    return await postUrl(url, { action: 'init', limit })
}

// Выдача по фильтру rows одним запросом: счётчики и первые страницы
// обеих групп — { status, total, new: { total, data }, used: { total, data } }
const getCatalogSearch = async (rows, limit) => {
    return await postUrl(url, { action: 'search', rows, limit })
}

// Одна позиция по id
const getCatalogItem = async (id) => {
    return await postUrl(url, { id: Number(id) })
}

export { getCatalog, getCatalogInit, getCatalogSearch, getCatalogItem }
